module.exports = __webpack_public_path__ + "static/img/gallery_close.ccc4788d.svg";